import { render } from "./ProductSelectionTrademarksSelection.vue?vue&type=template&id=55dfcdba&scoped=true&ts=true"
import script from "./ProductSelectionTrademarksSelection.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionTrademarksSelection.vue?vue&type=script&lang=ts"

import "./ProductSelectionTrademarksSelection.vue?vue&type=style&index=0&id=55dfcdba&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dfcdba"]])

export default __exports__